import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FiAward, FiTrendingUp, FiHeart, FiFlag } from 'react-icons/fi';

export default function About() {
  
  const team = [
    { name: 'Vinod Nayak', role: 'Founder & CEO', bio: 'Visionary entrepreneur passionate about transforming hospitality with technology. Vinod Nayak leads DineEase with a relentless focus on innovation, growth, and customer success.', img: require('../assets/img/about/ceo.jpg') },
    { name: 'Sunandhita Roy', role: 'Co-Founder & CTO', bio: "Full-stack technologist and architect of DineEase's platform. Sunandhita Roy is driven by a mission to build scalable, secure, and delightful digital experiences for restaurants and diners.", img: require('../assets/img/about/cto.jpg') }
  ];

  return (
    <>
      <Header />
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-gray-800 py-20 px-4 sm:px-6 lg:px-8 text-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 drop-shadow-lg">Building the Future of <span className="bg-white/10 px-2 rounded">Dining</span></h1>
          <p className="text-2xl md:text-3xl font-medium mb-8 max-w-3xl mx-auto drop-shadow">EasiDine is a bold new startup reimagining how restaurants and guests connect—through seamless technology, data-driven insights, and a passion for hospitality.</p>
          
        </div>
        {/* Decorative shapes */}
        <div className="absolute top-0 left-0 w-40 h-40 bg-white/10 rounded-full blur-3xl -z-1"></div>
        <div className="absolute bottom-0 right-0 w-60 h-60 bg-white/20 rounded-full blur-3xl -z-1"></div>
      </section>

      {/* Mission & Vision */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto text-center mb-16">
          <div className="flex flex-col items-center mb-6">
            <div className="p-4 bg-orange-100 rounded-full mb-2">
              <FiAward className="text-orange-600 text-3xl" />
            </div>
            <h2 className="text-4xl font-bold text-gray-900">Our Mission</h2>
          </div>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6">To empower restaurants of all sizes with digital tools that elevate guest experiences, streamline operations, and unlock new growth—making dining smarter, safer, and more delightful for everyone.</p>
          <div className="flex flex-col md:flex-row justify-center gap-8 mt-8">
            <div className="flex-1 bg-orange-50 p-8 rounded-2xl shadow-md">
              <FiTrendingUp className="text-orange-600 text-3xl mb-4" />
              <h3 className="text-xl font-semibold mb-2">For Restaurants</h3>
              <p className="text-gray-700">Accelerate your business with real-time analytics, contactless ordering, and effortless menu management—all in one platform.</p>
            </div>
            <div className="flex-1 bg-orange-50 p-8 rounded-2xl shadow-md">
              <FiHeart className="text-orange-600 text-3xl mb-4" />
              <h3 className="text-xl font-semibold mb-2">For Diners</h3>
              <p className="text-gray-700">Enjoy a frictionless, personalized dining journey—scan, order, and pay with confidence and ease.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline / Journey */}
      <section className="py-16 bg-gradient-to-br from-orange-50 to-amber-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">Our Journey</h2>
          <ol className="relative border-l-4 border-orange-300 ml-4">
            <li className="mb-12 ml-6">
              <span className="absolute -left-6 flex items-center justify-center w-12 h-12 bg-orange-500 rounded-full ring-4 ring-white">
                <FiFlag className="text-white text-2xl" />
              </span>
              <div className="bg-white rounded-xl shadow-md p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">2024: The Spark</h3>
                <p className="text-gray-700">EasiDine was born from a shared vision: to help restaurants thrive in a digital-first world. Our MVP launched with a handful of passionate partners.</p>
              </div>
            </li>
            <li className="ml-6">
              <span className="absolute -left-6 flex items-center justify-center w-12 h-12 bg-orange-400 rounded-full ring-4 ring-white">
                <FiTrendingUp className="text-white text-2xl" />
              </span>
              <div className="bg-white rounded-xl shadow-md p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">2025: Rapid Growth</h3>
                <p className="text-gray-700">With relentless innovation and customer obsession, we're scaling across India—empowering hundreds of restaurants and delighting thousands of diners every day.</p>
              </div>
            </li>
          </ol>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">Meet the Founders</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden transition-transform hover:scale-105 flex flex-col items-center">
                <img src={member.img} alt={member.name} className="w-36 h-36 rounded-full object-cover border-4 border-orange-200 mt-8 mb-4 shadow-lg" />
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-orange-600 mb-2 font-medium">{member.role}</p>
                  <p className="text-gray-600 mb-4">{member.bio}</p>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      
      
      <Footer />
    </>
  );
}